module.exports = __webpack_public_path__ + "static/media/psnmb.54fde953.png";